module.exports = __webpack_public_path__ + "static/media/vencimientostickets-07-verde.405e08f5.svg";